import React, { useState, useEffect } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import deepFlattenToObject from "../../../../functions/deepFlattenToObject";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Request_Get_Registers_Fuzzy_Search } from "../../Registers/api/Request_Get_Registers_Fuzzy_Search";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import { Send_SEF_Emails } from "../../Registers/api/Send_SEF_Emails";
import { Send_Summer_SEF_Emails } from "../api/Send_Summer_SEF_Emails";
import { Send_Arrival_Departure_Emails } from "./api/Send_Arrival_Departure_Emails";

function ArrivalDepartureEmails() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------
  // Assuming you have a state to store the fetched data
  const [Registers, setRegisters] = useState([
    {
      BasicInfo: {
        First_Name: "NOT FOUND",
        Created_At: "2024-10-01",
        ProgrammeTitle: "Summer Programme",
        ProgrammeVarient: "In Person",
        ProgrammeDate: "(3rd November 2024)",
      },
      Notes: [
        {
          Note: "Arrival Departure Email Sent",
          DateTime: "2024-10-07T10:00:00Z",
        },
        {
          Note: "Arrival Departure Email Sent",
          DateTime: "2024-10-08T10:00:00Z",
        },
        {
          Note: "Arrival Departure Email Sent",
          DateTime: "2024-10-09T10:00:00Z",
        },
      ],
    },
  ]);
  //Load those who may need an email
  useEffect(() => {
    Request_Get_Registers_Fuzzy_Search(
      "Registers_2025",
      "All",
      {
        ProgrammeTitle: "Summer",
        ProgrammeVarient: "Accom",
        SEF: "Complete or Awaiting_Review",
        SummerArrivalDepartureProgress: "Incomplete or In_Progress",
        //First_Name: "test",
      },
      60000,
      setRegisters,
      logout
    );
  }, []);

  function handleSend(e, chosenArray) {
    e.preventDefault();

    const AttendeesToSend = chosenArray.filter((Attendee) =>
      dueArrivalDepartureEmail(
        getLastEmailSentDate(Attendee),
        Attendee.BasicInfo?.ProgrammeVarient,
        Attendee.BasicInfo?.ProgrammeDate
      )
    );

    AttendeesToSend.forEach((Attendee) => {
      console.log("Attendee");
      console.log(Attendee.BasicInfo?.First_Name);
      let newNote = {
        DateTime: new Date().toISOString(),
        Note: "Arrival Departure Email Sent",
        Staff_ID: localStorage.getItem("_id"),
      };
      console.log("Arrival Departure Email Sent");
      if (
        Attendee.BasicInfo?.ProgrammeVarient.toLowerCase().includes("accom")
      ) {
        Send_Arrival_Departure_Emails(
          Attendee,
          newNote,
          getCountOfEmailsSent(Attendee),
          logout
        );
      }
    });
    console.log("-----End Send-----");
  }

  //Count how many Notes are in the Notes array with a value of Note: "Arrival Departure Email Sent"
  function getCountOfEmailsSent(Attendee) {
    let count = 0;
    if (!Attendee.Notes) {
      return count;
    }
    if (!Array.isArray(Attendee.Notes)) {
      return count; // Handle case where Notes is not an array
    }
    Attendee.Notes.forEach((note) => {
      if (note.Note === "Arrival Departure Email Sent") {
        count++;
      }
    });
    return count;
  }

  //find when the last Arrival Departure Email was sent
  function getLastEmailSentDate(Attendee) {
    let lastEmailSentDate = null;
    if (!Attendee.Notes) {
      return lastEmailSentDate;
    }
    if (!Array.isArray(Attendee.Notes)) {
      return lastEmailSentDate; // Handle case where Notes is not an array
    }
    Attendee.Notes.forEach((note) => {
      if (note.Note && note.Note === "Arrival Departure Email Sent") {
        const date = new Date(note.DateTime);
        if (!lastEmailSentDate || date > lastEmailSentDate) {
          lastEmailSentDate = date;
        }
      }
    });
    //if lastEmailSentDate is null, return null. else return date in DD/MM/YYYY format
    if (!lastEmailSentDate) {
      return null;
    }
    return lastEmailSentDate;
  }

  function getDateFormat(date) {
    if (!date) {
      return null; // Handle null case
    }
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);
    const [day, month, year] = formattedDate.split("/");
    return `${day}/${month}/${year}`;
  }

  function dueArrivalDepartureEmail(date, Varient, ProgrammeDate) {
     if(ProgrammeDate === "(7th July - 18th July 2025)" || ProgrammeDate === "(28th July - 8th August 2025)") {
      return false;
    }
    if (!date) {
      return true; // Handle null case
    }
     
    if (!Varient) {
      return false; // No need to send email for In Person
    }
    if (Varient.toLowerCase().includes("accom")) {
      const today = new Date();
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);
      return date < sevenDaysAgo;
    } else {
      return null;
    }
  }

  //-----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "95%",
            maxHeight: "800px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            View Arrival Departure Emails
          </Typography>
          <button
            style={{ width: "100px" }}
            onClick={(e) => handleSend(e, Registers)}
          >
            Send
          </button>

          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  <>{SimpleTableHeader("Name")}</>
                  <>{SimpleTableHeader("Title")}</>
                  <>{SimpleTableHeader("Date")}</>
                  <>{SimpleTableHeader("Varient")}</>
                  <>{SimpleTableHeader("EC")}</>
                  <>{SimpleTableHeader("Submission Date")}</>
                  <>{SimpleTableHeader("SEF Stage")}</>
                  <>{SimpleTableHeader("Emails Sent")}</>
                  <>{SimpleTableHeader("Last Email")}</>
                  <>{SimpleTableHeader("Due?")}</>
                </TableRow>
              </TableHead>
              <TableBody>
                {Registers.map((Register, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        Register?.MetaData?.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : Register?.MetaData?.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : Register?.MetaData?.Bursary === "Yes"
                          ? "rgba(144, 238, 144, 0.5)"
                          : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    {SimpleTableCell(
                      Register?.BasicInfo?.First_Name +
                        " " +
                        Register?.BasicInfo?.Last_Name
                    )}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeTitle)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeDate)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeVarient)}
                    {SimpleTableCell(
                      Register?.IPInfo?.EC_ID &&
                        Register?.IPInfo?.EC_ID !== "" &&
                        Register?.IPInfo?.EC_ID !== null &&
                        Register?.IPInfo?.EC_ID !== undefined
                        ? "EC Booking"
                        : "Non EC Booking"
                    )}
                    {SimpleTableCell(Register?.SEFInfo?.SEFSubmissionDate)}
                    {SimpleTableCell(Register?.SEFInfo?.SEF)}
                    {SimpleTableCell(getCountOfEmailsSent(Register))}
                    {SimpleTableCell(
                      getDateFormat(getLastEmailSentDate(Register))
                    )}{" "}
                    {SimpleTableCell(
                      dueArrivalDepartureEmail(
                        getLastEmailSentDate(Register),
                        Register.BasicInfo?.ProgrammeVarient,
                        Register.BasicInfo?.ProgrammeDate

                      )
                        ? "Yes"
                        : "No"
                    )}
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {dueArrivalDepartureEmail(
                        getLastEmailSentDate(Register),
                        Register.BasicInfo?.ProgrammeVarient,
                        Register.BasicInfo?.ProgrammeDate
                      ) ? (
                        <button onClick={(e) => handleSend(e, [Register])}>
                          Send
                        </button>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
}

export default ArrivalDepartureEmails;
